import { Divider } from 'antd';
import { formatWithPostfixOrEmpty } from 'shared/utils/format-with-postfix-or-empty';
import { numberFormatter } from 'shared/utils/numbers/formatter.ts';
import { formatDateTime } from 'shared/utils/time/format-date-time';
import { TransportSubTypes } from 'types/transport';
import styles from './trip-step.module.scss';
import type { ITripStepProps } from './types';

export const TripStep: React.FC<ITripStepProps> = (props) => {
  const { step, isLast } = props;
  return (
    <div className={styles.stepContainer}>
      <p>
        {formatDateTime(step.startDate)} → {step.endDate ? formatDateTime(step.endDate) : 'In Progress'}
      </p>
      {step.truck?.plateNumber && (
        <p>
          <strong>Truck Plate Number:</strong> {step.truck.plateNumber} ({TransportSubTypes[step.truck.subType]})
        </p>
      )}
      {step.trailer?.plateNumber && (
        <p>
          <strong>Trailer Plate Number:</strong> {step.trailer.plateNumber} ({TransportSubTypes[step.trailer.subType]})
        </p>
      )}
      <p>
        <strong>User:</strong> {step.user.name}
      </p>
      <p>
        <strong>Cost per km:</strong> {formatWithPostfixOrEmpty(step.costPerKm, '€')}
      </p>
      {step.startMileage && step.endMileage && (
        <>
          <p>
            <strong>Mileage:</strong> {numberFormatter(step.startMileage)} km → {numberFormatter(step.endMileage)} km
          </p>
          <p>
            <strong>Mileage Difference:</strong> {numberFormatter(step.endMileage - step.startMileage)} km
          </p>
        </>
      )}
      <p>
        <strong>Total Cost:</strong> {formatWithPostfixOrEmpty(step.cost, '€')}
      </p>
      {!isLast && <Divider />}
    </div>
  );
};
